var map = {
	"./ICON-EAT-IN.png": "1488",
	"./Iconic-logo.png": "fe2d",
	"./alert-icon.png": "4121",
	"./cust_segmentation.png": "38ee",
	"./g_maps.png": "8ba4",
	"./icon.png": "555a",
	"./just-eat-orange-logo.png": "f10f",
	"./kiosk_short.png": "a2f4",
	"./kiosk_short_offline.png": "ead2",
	"./logo-iconic-landscape.png": "88f6",
	"./logo-retex-short.png": "3b43",
	"./logo_home.png": "fb57",
	"./no_result.jpg": "8911",
	"./no_result.png": "00fe",
	"./scan_card.gif": "8b31"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6e22";